import { render, staticRenderFns } from "./ResumeCard.vue?vue&type=template&id=4aacf664&scoped=true&"
import script from "./ResumeCard.vue?vue&type=script&lang=js&"
export * from "./ResumeCard.vue?vue&type=script&lang=js&"
import style0 from "./ResumeCard.vue?vue&type=style&index=0&id=4aacf664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aacf664",
  null
  
)

export default component.exports